import { routeUtil } from '@cmg/common';
import React from 'react';
import { Route, Routes } from 'react-router-dom';

import routeFactory from '../../../common/util/routeFactory';
import RolodexFirmCreateRoute from './RolodexFirmCreateRoute';
import RolodexFirmImportRoute from './RolodexFirmImportRoute';

const rel = (routePath: string) => {
  return routeUtil.getRelativeRoutePath(routeFactory.rolodexFirmNew.routePath, routePath);
};

const RolodexFirmNewRoute: React.FC = () => {
  return (
    <Routes>
      <Route
        path={rel(routeFactory.rolodexFirmImport.routePath)}
        element={<RolodexFirmImportRoute />}
      />
      <Route
        path={rel(routeFactory.rolodexFirmCreate.routePath)}
        element={<RolodexFirmCreateRoute />}
      />
    </Routes>
  );
};

export default RolodexFirmNewRoute;
